<template>
	<div v-interpolation
		 class="richtext"
		 v-html="data" />
</template>


<script setup>
defineProps({
	data: {
		type: String,
		default: '',
	}
})
</script>